const travelingKnots = new Set();
let listenersBound = false;
let animationFrame = 0;

function updateAllTravelingKnots() {
  animationFrame = 0;
  travelingKnots.forEach((instance) => instance.update());
}

function scheduleTravelingKnotUpdate() {
  if (animationFrame) return;
  animationFrame = window.requestAnimationFrame(updateAllTravelingKnots);
}

function resizeAllTravelingKnots() {
  travelingKnots.forEach((instance) => instance.measure());
  scheduleTravelingKnotUpdate();
}

function bindSharedListeners() {
  if (listenersBound) return;
  listenersBound = true;
  document.addEventListener('scroll', scheduleTravelingKnotUpdate, {
    capture: true,
    passive: true,
  });
  window.addEventListener('resize', resizeAllTravelingKnots, { passive: true });
}

function unbindSharedListeners() {
  if (!listenersBound || travelingKnots.size) return;
  listenersBound = false;
  document.removeEventListener('scroll', scheduleTravelingKnotUpdate, true);
  window.removeEventListener('resize', resizeAllTravelingKnots);
  if (animationFrame) {
    window.cancelAnimationFrame(animationFrame);
    animationFrame = 0;
  }
}

function findScrollTarget(element) {
  const horizonScrollRoot = element.closest('.page-wrapper');
  if (horizonScrollRoot) {
    const style = window.getComputedStyle(horizonScrollRoot);
    const isScrollable = /(auto|scroll)/.test(style.overflowY);
    const hasScrollRange =
      horizonScrollRoot.scrollHeight > horizonScrollRoot.clientHeight + 1;

    if (isScrollable && hasScrollRange) return horizonScrollRoot;
  }

  let parent = element.parentElement;

  while (parent) {
    const style = window.getComputedStyle(parent);
    const scrollable = /(auto|scroll)/.test(style.overflowY);
    if (scrollable) return parent;
    parent = parent.parentElement;
  }

  return window;
}

class KeshRugTravelingKnot extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.road = this.querySelector('[data-knot-road]');
    this.stations = [...this.querySelectorAll('[data-knot-station]')];
    this.horizontal = {
      path: this.querySelector('[data-knot-path-horizontal]'),
      knot: this.querySelector('[data-knot-horizontal]'),
      length: 0,
    };
    this.vertical = {
      path: this.querySelector('[data-knot-path-vertical]'),
      knot: this.querySelector('[data-knot-vertical]'),
      length: 0,
    };
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.handleMotionChange = this.handleMotionChange.bind(this);

    if (this.motionQuery.addEventListener) {
      this.motionQuery.addEventListener('change', this.handleMotionChange);
    } else {
      this.motionQuery.addListener(this.handleMotionChange);
    }

    travelingKnots.add(this);
    bindSharedListeners();
    this.prepare();
  }

  disconnectedCallback() {
    travelingKnots.delete(this);
    if (this.motionQuery?.removeEventListener) {
      this.motionQuery.removeEventListener('change', this.handleMotionChange);
    } else {
      this.motionQuery?.removeListener(this.handleMotionChange);
    }
    delete this.dataset.ready;
    unbindSharedListeners();
  }

  handleMotionChange() {
    this.prepare();
  }

  prepare() {
    const shouldAnimate = this.dataset.animate === 'true' && !this.motionQuery.matches;
    this.classList.toggle('is-enhanced', shouldAnimate);
    this.classList.toggle('is-static', !shouldAnimate);

    if (!shouldAnimate) {
      this.stations.forEach((station) => station.classList.add('is-lit'));
      return;
    }

    this.measure();
    this.update();
  }

  measure() {
    this.horizontal.length = this.horizontal.path?.getTotalLength() || 0;
    this.vertical.length = this.vertical.path?.getTotalLength() || 0;
  }

  update() {
    if (!this.classList.contains('is-enhanced') || !this.road) return;

    const currentScrollTarget = findScrollTarget(this);
    const scrollRoot = currentScrollTarget === window ? null : currentScrollTarget;
    const viewportHeight = scrollRoot?.clientHeight || window.innerHeight;
    const viewportTop = scrollRoot?.getBoundingClientRect().top || 0;
    const desktop = window.innerWidth >= 990;
    const progressRect = (desktop ? this : this.road).getBoundingClientRect();
    const rawProgress = desktop
      ? (viewportTop + viewportHeight * 0.48 - progressRect.top) / (progressRect.height * 0.72)
      : (viewportTop + viewportHeight * 0.72 - progressRect.top) / progressRect.height;
    const progress = Math.max(0, Math.min(1, rawProgress));
    const mode = desktop ? this.horizontal : this.vertical;

    if (mode.path && mode.knot && mode.length) {
      const point = mode.path.getPointAtLength(progress * mode.length);
      mode.knot.setAttribute('cx', point.x);
      mode.knot.setAttribute('cy', point.y);
    }

    this.stations.forEach((station) => {
      station.classList.toggle('is-lit', progress >= Number.parseFloat(station.dataset.at));
    });
  }
}

if (!customElements.get('kr-traveling-knot')) {
  customElements.define('kr-traveling-knot', KeshRugTravelingKnot);
}
